<template>
	<div class="card">
		<div class="box box-left">
			<div class="header">  <el-checkbox v-model="leftAllChecked"  @change='lAllCheck'>用户列表</el-checkbox></div>
			<div style="display: flex;justify-content: center;" class="inp">
				<input placeholder="搜索用户昵称" @keydown.enter="searchUser" v-model="keyword"></input>
			</div>
			<div class="body">
				<el-checkbox-group v-model="leftCheckBoxValue" @change="leftCheckedHandler">
					<div  v-for="(item,index) in leftData" class="checkbox" :key="item.id">
						<el-checkbox :label="item.id" >{{item.nickname}}</el-checkbox>
					</div>
				</el-checkbox-group>
				</div>
				<div class="footer">
					<div class="pagination">
						<el-pagination
						  small
						  :page-size="serverPage.per_page"
						  layout="prev, pager, next"
						 @current-change='currentChange'
						  :total="serverPage.total*1">
						</el-pagination>
					</div>
				</div>
		</div>
		<div class="btns">
			<div>
				<el-button type="primary" @click="leftToRight" :disabled='leftCheckBoxValue.length == 0 '><i class="el-icon-arrow-right"></i></el-button>
			</div>
		</div>
		<div  class="box box-right">
			<div class="header">  <el-checkbox v-model="rightAllChecked" @change='rAllCheck'>已选用户</el-checkbox> 
			<el-button style="margin-left: 100px;padding: 5px;" :disabled='rightCheckBoxValue.length == 0' @click="removeChecked">移除</el-button>
			</div>
			<div class="body">
				<el-checkbox-group v-model="rightCheckBoxValue"  @change="rightCheckedHandler">
					<div  v-for="(item,index) in rightData" class="checkbox">
						<el-checkbox :label="item.id" >{{item.nickname}}</el-checkbox>
					</div>
				</el-checkbox-group>
				</div>
			</div>
			
		</div>
</template>

<script>
	export default {
		props:{
			dis:{
				type:Boolean
			},
			pageType:{
				type:String,
				default:'add'
			},
			usersId:{
				type:String,
			}
		},
		data() {
			return {
				leftAllChecked:false,
				rightAllChecked:false,
				leftChecked:[],
				leftCheckBoxValue:[],
				rightCheckBoxValue:[],
				rightChecked:[],
				rightData:[],
				leftData:[
					{id:1,nickename:'23'},
					{id:2,nickename:'123'},
				],
				removeDisable:false,
				serverPage:{
					total:0,
					per_page:10,
					page:1,
				},
				keyword:''
			}
		},
		created() {
			this.userList()
			if(this.pageType == 'edit' & this.usersId != null & this.usersId != ''){
				console.log(this.pageType,this.usersId);
				this.getWhiteList()
			}
		},
		watch:{
			usersId:{
				handler(n,o){
					if(this.pageType == 'edit' & this.usersId != null & this.usersId != ''){
						this.getWhiteList()
					}
				}
			}
		},
		methods: {
			async getWhiteList(){
				const list = await this.$api.userWhiteList({ids:this.usersId})
				this.rightData = list.data
				console.log(list);
			},
			async userList(){
				const list =await this.$api.getUserLists({keywords:this.keyword,page:this.serverPage.page})
				this.serverPage.total = list.data.total
				this.serverPage.per_page = list.data.per_page
				this.leftData = list.data.data
			},
			async searchUser(){
				const list =await this.$api.getUserLists({keywords:this.keyword,page:1})
				this.serverPage.total = list.data.total
				this.per_page = list.data.per_page
				this.leftData = list.data.data
			},
			currentChange(e){
				this.serverPage.page = e
				this.userList()
			},
			leftToRight(){
				this.rightData = this.rightData.concat(this.leftChecked.filter(item => !this.rightData.some(dataItem => dataItem.id === item.id)));
				this.leftCheckBoxValue = []
				const check = this.rightData.map(item=> item.id)
				this.$emit("leftToRight", check) 
			},
			rightCheckedHandler(e){
				const result = this.rightData.filter(item => this.rightCheckBoxValue.includes(item.id));
				this.rightChecked = result
			},
			leftCheckedHandler(e){
				 const result = this.leftData.filter(item => this.leftCheckBoxValue.includes(item.id));
				this.leftChecked = result
			},
			removeChecked(){
					const result = this.rightData.filter(item1 => !this.rightChecked.some(item2 => item2.id === item1.id));
					 // this.rightCheckBoxValue = result.map(item=> item.id)
					 this.rightData = result
					 this.rightChecked = result
					 const check = this.rightData.map(item=> item.id)
					 this.$emit("removeChecked", check) 
			},
			lAllCheck(e){
				if(e){
					this.leftCheckBoxValue = this.leftData.map(item=> item.id)
					this.leftCheckedHandler()
				}else{
					this.leftCheckBoxValue = []
				}
			},
			rAllCheck(e){
				if(e){
					this.rightCheckBoxValue = this.rightData.map(item=> item.id)
					this.rightCheckedHandler()
				}else{
					this.rightCheckBoxValue = []
				}
			},
		},

	}
</script>

<style scoped lang="less">
	.inp{
		margin-top: 10px;
		input{
			width: 90%;
			border-radius: 20px;
			height: 30px;
			padding: 5px;
			padding-left: 8px;
			box-sizing: border-box;
			border: 1px solid rgb(210, 210, 210);
		}
		
	}
	.checkbox{
		margin-bottom: 8px;
	}
	.btns{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		width: 150px;
		&>div{
			margin: 10px;
		}
	}
	.footer{
		position: absolute;
		bottom: 0;
		left:20px;
		.pagination{
			margin: 0 auto;
			width: 220px;
			position: absolute;
			display: flex;
			justify-content: center;
			box-sizing: border-box;
		}
	}
	.body{
		padding: 15px;
		overflow-y: auto;
	}
	.card{
		display: flex;
		align-items: center;
		max-width: 700px;
		justify-content: space-between;
	}
	.header{
		padding: 15px;
		background: #F5F7FA;
	}
.box{
	border: 1px solid #EBEEF5;
	position: relative;
	border-radius: 10px;
	width: 260px;
	min-height: 350px;
}
</style>